export default __webpack_public_path__ + "static/media/email.e9846af1.svg";